module.exports = __webpack_public_path__ + "media/images/proof_links/colored/telegram-55c3f6ff336dc3b454a6dea066b8903e.svg";